import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/corpus-christi")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Boat Covers Corpus Christi | Marine Canvas, Awnings & Sail Shades | Texas Made Shade",
      description: "Boat Covers Corpus Christi — custom marine canvas, T-tops, bimini tops, mooring covers, awnings and sail shades for Corpus Christi & the Coastal Bend.",
      image: hero,
      socialTitle: "Boat Covers Corpus Christi — Texas Made Shade",
      socialDescription: "Boat Covers Corpus Christi: Sunbrella® Marine canvas, T-tops, bimini tops and mooring covers patterned for the Coastal Bend.",
      keywords: "pergola covers Corpus Christi, pergola covers Texas, custom pergola covers Corpus Christi, aluminum pergola covers Corpus Christi, boat covers Corpus Christi, marine canvas Corpus Christi, bimini tops Corpus Christi, T-top canvas Corpus Christi, mooring covers Corpus Christi, awnings Corpus Christi, sail shades Corpus Christi, awning company Corpus Christi, Coastal Bend boat covers, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Corpus Christi", "Nueces County"),
  }),
  component: () => <CityHomePage city="Corpus Christi" region="Nueces County" />,
});
